import { ColumnToolTip } from '../../features';
import { VendorCallLogResponseModel } from '../../models/api/Call';
import { formatUSPhoneNumber } from '../../utils/phoneNumberFormatting';

const formatDuration = (durationMs?: number | null): string => {
  if (!durationMs || durationMs < 0) return '-';
  const totalSeconds = Math.floor(durationMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

const formatDateTime = (timestamp?: number | null): string => {
  if (!timestamp || timestamp <= 0) return '-';
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export function useFunctionalityVendorCallLogColumns() {
  const vendorCallLogColumns = [
    {
      name: <ColumnToolTip data={'Call Sid'} />,
      selector: (row: VendorCallLogResponseModel) =>
        row.callSid ? <ColumnToolTip data={row.callSid} /> : '-',
      width: '140px',
    },
    {
      name: <ColumnToolTip data={'Call Id'} />,
      selector: (row: VendorCallLogResponseModel) =>
        row.callId ? <ColumnToolTip data={row.callId} /> : '-',
      width: '140px',
    },
    {
      name: <ColumnToolTip data={'Client Number'} />,
      selector: (row: VendorCallLogResponseModel) => {
        const rawValue = row.clientNumber ?? '';
        return (
          <ColumnToolTip
            data={rawValue ? formatUSPhoneNumber(rawValue) || rawValue : '-'}
          />
        );
      },
      width: '140px',
    },
    {
      name: <ColumnToolTip data={'Vendor'} />,
      selector: (row: VendorCallLogResponseModel) =>
        row.callStatus ? <ColumnToolTip data={row.callStatus} /> : '-',
      width: '180px',
    },
    {
      name: <ColumnToolTip data={'Started At'} />,
      selector: (row: VendorCallLogResponseModel) => (
        <ColumnToolTip data={formatDateTime(row.callStartedAt)} />
      ),
      width: '160px',
    },
    {
      name: <ColumnToolTip data={'Ended At'} />,
      selector: (row: VendorCallLogResponseModel) => (
        <ColumnToolTip data={formatDateTime(row.callEnded)} />
      ),
      width: '160px',
    },
    {
      name: <ColumnToolTip data={'Duration'} />,
      selector: (row: VendorCallLogResponseModel) => (
        <ColumnToolTip data={formatDuration(row.durationMilliseconds)} />
      ),
      width: '120px',
    },
    {
      name: <ColumnToolTip data={'Language'} />,
      selector: (row: VendorCallLogResponseModel) =>
        row.languageName ? <ColumnToolTip data={row.languageName} /> : '-',
      width: '120px',
    },
    {
      name: <ColumnToolTip data={'Company'} />,
      selector: (row: VendorCallLogResponseModel) => {
        return row.companyName ? <ColumnToolTip data={row.companyName} /> : '-';
      },
      minWidth: '160px',
    },
    {
      name: <ColumnToolTip data={'Pin'} />,
      selector: (row: VendorCallLogResponseModel) =>
        row.pin ? <ColumnToolTip data={row.pin} /> : '-',
      width: '90px',
    },
    {
      name: <ColumnToolTip data={'Vendor Id'} />,
      selector: (row: VendorCallLogResponseModel) =>
        row.id ? <ColumnToolTip data={row.id} /> : '-',
      minWidth: '180px',
      grow: 2,
    },
  ];

  return {
    vendorCallLogColumns,
  };
}

